import { useQuery } from '@apollo/client/react';

import { AdminLaunchClientSetupDocument } from '../../../graphql/types';

/** The client settings, offices and test users the setup steps edit. */
export const useClientSetup = (clientId: string | undefined) =>
  useQuery(AdminLaunchClientSetupDocument, {
    variables: { id: clientId ?? '', clientId: clientId ?? '' },
    skip: !clientId,
    fetchPolicy: 'cache-and-network',
  });
